import React from 'react';
import { Reveal } from './ui/Reveal';
import { Linkedin, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-950 py-12 border-t border-gold-500" data-id="element-211">
      <div className="container mx-auto px-4 text-center" data-id="element-212">
        <Reveal data-id="element-213">
          <h2 className="text-2xl font-heading font-bold text-white uppercase tracking-widest mb-4" data-id="element-214">
            Guy C. Beougher
          </h2>
          <p className="text-slate-500 text-sm mb-8 max-w-md mx-auto" data-id="element-215">
            Enterprise Defense Logistics Leadership &bull; Strategic Advisory
            &bull; Board Governance
          </p>
          <div className="flex justify-center space-x-6 mb-8" data-id="element-216">
            <a href="https://linkedin.com/in/guybeougher" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-gold-500 transition-colors" aria-label="LinkedIn" data-id="element-217">
              <Linkedin className="w-6 h-6" data-id="element-218" />
            </a>
            <a href="mailto:guy.beougher@gmail.com" className="text-slate-400 hover:text-gold-500 transition-colors" aria-label="Email" data-id="element-219">
              <Mail className="w-6 h-6" data-id="element-220" />
            </a>
          </div>
          <p className="text-slate-600 text-xs uppercase tracking-widest" data-id="element-221">
            &copy; {new Date().getFullYear()} Guy C. Beougher. All Rights
            Reserved.
          </p>
        </Reveal>
      </div>
    </footer>;
}